/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Manual/WIFEndpointDraftMessageCard" />
import React = require("react");
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Link } from "VSSUI/Link";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";


export function WIFEndpointDraftMessageCard(): JSX.Element {
    const documentationHref = "https://aka.ms/azdo-rm-workload-identity/";
    return (<MessageCard
        className="flex-self-stretch margin-bottom-16"
        severity={MessageCardSeverity.Info}
    >
        <div>
            <FormatComponent format={Resources.AzureRMOidcFederationDraftMessage2}>
                <span className="font-semibold">{Resources.WorkloadIdentityFederationIssuerLabel}</span>
                <span className="font-semibold">{Resources.WorkloadIdentityFederationSubjectLabel}</span>
                <Link href={documentationHref}>{Resources.Documentation}</Link>
            </FormatComponent>
        </div>
    </MessageCard>);
}
